// ADD API URLS BELOW
export const API_URLS = {
    EVENTS_LISTING: '/api/events/list',
    FORM_SUBMIT: '/api/form-submit',
    NEWS_LISTING: '/api/news/list',
};
